import React, { Component, useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime} from '../../Constants/constants';
import { NavLink } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { decodeData} from '../../Constants/constants';
import { useLocation } from 'react-router-dom';

const UserCreate = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [createUser, setCreateUser] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingPost, setLoadingPost] = useState(false);
    const [formData, setFormData] = useState({
        profileUrl: "", 
        profile_picture: "", 
        selectedProfilePicture: "", 
        selectedProfilePictureName: "", 
        fileError: null, 
        user_name: "",
        user_email: "",
        user_login_id: "",
        user_login_password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    const getList = () => {
        const headers = apiHeaderJSON;
        // { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, "x-company-id": localStorage.getItem("company_id_master"), "x-user-id": localStorage.getItem("user_id_master") };
        axios.get(`${apiURL}User/GetAdminUserList`, { headers })
        .then((response) => {
            let data = response.data;
            console.log("GetCompanyAdminList =>",data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.module_id, label: val?.header_name }
                });
                setParentHeaderRows(rows);  
                setRows(data?.data);
            } else {
                setParentHeaderRows([]);
                setRows([]);
                console.error("Error fetching list");
            }
            setLoadingPost(false);
        }).catch(function (error) {
            console.log("error", error);
            setLoadingPost(false);
        });
    }


    useEffect(() => {
        getList();
    },[]);

    useEffect(() => {
        if (isChanged) {
            getList();
            setIsChanged(false);
        }
    }, [isChanged]);


    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleToggleSwitch = (user_id, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    company_id: formData?.companyId,
                    company_user_id: user_id,
                    activated: toggleButton ? "1" : "0",
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJSON;
                // { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, "x-company-id": localStorage.getItem("company_id_master"), "x-user-id": localStorage.getItem("user_id_master") };
                // setToggleButton(!toggleButton);
                console.log(data);
                axios
                    .post(`${apiURL}User/HandleAdminUserStatus`, data, {headers,})
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                            
                            getList();
                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    const getInfo = (row) => {
        // const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'company_id': localStorage.getItem("company_id_master"), 'user_id': localStorage.getItem("user_id_master") };
        // axios.get(`${apiURL}CompanyMasters/GetHeaderInfo`,
        //     {
        //         params: {
        //             moduleId: id
        //         },
        //         headers
        //     }).then((response) => {
        //         const { success, result } = response.data;
        //         console.log(response?.data);
        //         if (success === true) {
        //             setFormData({
        //                 ...formData,
        //                 module_id: result[0]?.module_id,
        //                 headerName: result[0]?.header_name,
        //                 headerPath: result[0]?.header_path,
        //                 // headerStatus: result[0]?.header_status || "0",
        //                 parentId: result[0]?.parent_id,
        //             });

        //         } else {

        //         }
        //     });
        setFormData({
            ...formData,
            user_id: row?.company_user_id,
            user_name: row?.company_user_name,
            user_email: row?.company_user_email,
            user_login_id: row?.company_user_login_id,
            user_login_password: row?.company_user_login_password,
            selectedProfilePicture: row?.profile_url,
        })
        setCreateUser(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        let data = {
            file: formData?.profile_picture || null,
            company_user_id: formData?.user_id || null,
            company_user_name: formData?.user_name,
            profile_image: formData?.profile_image,
            company_user_email: formData?.user_email,
            company_user_login_id: formData?.user_login_id,
            company_user_login_password: formData?.user_login_password,
            date: currentDateAndTime(),

        }
        const headers = apiHeaderFile;
        // console.log("formData?.companyId", formData?.companyId);
        // console.log("handleSubmit ~ form Data =======>>>", formData);
        axios
            .post(`${apiURL}User/CreateAdminUser`, data, {headers})
            .then((response) => {
                const { success, } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    });
                    setCreateUser(false);
                    setFormData({
                        user_id: "",
                        user_name: "",
                        user_email: "",
                        user_login_id: "",
                        user_login_password: "",
                    });
                    getList();
                    
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                }
                setLoadingPost(false);
            }).catch((error)=>{
                console.log(error);
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: "Opps..!! Something went wrong.",
                    icon: 'error',
                    showConfirmButton: true, 
                    allowOutsideClick:false
                });
                setLoadingPost(false);
            });

    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
    
        if (file) {
            // Validate file size and type
            const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
            const maxFileSize = 1 * 1024 * 1024; 
            if (!allowedTypes.includes(file.type)) {
                setErrors({ ...errors, fileError: "Invalid file type. Only jpg, jpeg and png are allowed." });
                return;
            }
            if (file.size >= maxFileSize) {
                setErrors({ ...errors, fileError: "File size must be less than 1MB." });
                return;
            }
            
    
     
            const reader = new FileReader();
            reader.onload = (event) => {
                setFormData({
                    ...formData,
                    profileUrl: "", 
                    profile_picture: file, 
                    selectedProfilePicture: event.target.result, 
                    selectedProfilePictureName: file.name, 
                    fileError: null, 
                });
                setErrors({ ...errors, fileError:""})
            };
            reader.readAsDataURL(file); 
        }
      };
      const removeProfilePicture = () => {
        setFormData({
          ...formData,
          profile_picture: null,
          selectedProfilePicture: null,
          selectedProfilePictureName: '',
        });
      };
      useEffect(()=>{
        console.log("errors",errors);
      },[errors])

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`User Master`} primary={`Home`} />
                    <div className="card">
                        <div className='card-header align-items-center justify-content-between d-flex'>
                            <h5 className=''>
                                Users List
                            </h5>
                           
                            { decodedData?.includes(2) && (
                            <button type="button" className="btn btn-primary"
                            onClick={()=>{
                                setFormData({
                                    ...formData,
                                    user_id: "",
                                    user_name: "",
                                    user_email: "",
                                    user_login_id: "",
                                    user_login_password: "",
                                });
                                setCreateUser(true);}} >
                            <i className="ri-menu-add-fill" />
                            Create User
                            </button>)}
                        </div>
                        {createUser && (
                        <div className="modal show" 
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                            }} >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalgridLabel">{formData.user_id? "Update" : "Create"} user</h5>
                                    <button type="button"
                                    disabled={loadingPost} className="btn-close" onClick={()=>{
                                        setFormData({
                                            ...formData,
                                            user_id: "",
                                            user_name: "",
                                            user_email: "",
                                            user_login_id: "",
                                            user_login_password: "",
                                            profile_picture: null,
                                            selectedProfilePicture: null,
                                            selectedProfilePictureName: '',
                                        });
                                        setCreateUser(false);
                                    }} aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                    <div className="container mt-2">
                                        <form className="row">
                                            <div className="col-md-6 mb-1">
                                                <label htmlFor="profile_pictureXX" className="form-label">
                                                    Profile Picture:
                                                </label>
                                                <br />
                                                <div className=' d-flex align-items-center gap-2'>
                                                    {/* Display the profile picture */}
                                                    {formData.selectedProfilePicture && (
                                                        <div
                                                            className="rounded-circle"
                                                            style={{
                                                                width: "55px",
                                                                height: "55px",
                                                                overflow: "hidden",
                                                                border:"1.5px solid #6464f4",
                                                                // marginRight: "10px",
                                                            }}
                                                        >
                                                            <img
                                                                src={formData.selectedProfilePicture || formData.profileUrl }
                                                                alt="Profile"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                    <div className=' d-flex align-items-center gap-3'>
                                                        {/* upload profile picture */}
                                                        {!formData.selectedProfilePictureName && (
                                                            <div>
                                                                <label htmlFor="profile_picture" className="btn btn-primary">
                                                                    Choose File
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id="profile_picture"
                                                                    name="profile_picture"
                                                                    accept="image/*"
                                                                    onChange={handleFileChange}
                                                                    className="form-control d-none"
                                                                />
                                                            </div>
                                                        )}
                                                        {formData.selectedProfilePictureName && (
                                                        <div className="mt-2 d-flex align-items-center mb-3">
                                                            
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                >
                                                                    <small className=' text-muted'>
                                                                    Selected file:
                                                                    </small><br/>
                                                                    <h6
                                                                    className="text-truncate mb-0"
                                                                    style={{
                                                                        maxWidth: "16rem", // Adjust max width to fit within the parent div
                                                                        overflow: "hidden",
                                                                        whiteSpace: "nowrap",
                                                                        textOverflow: "ellipsis",
                                                                    }}>{formData.selectedProfilePictureName}</h6> 
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close ms-2"
                                                                    aria-label="Close"
                                                                    onClick={removeProfilePicture}
                                                                ></button>
                                                            </div>
                                                        </div>
                                                        )}
                                                        
                                                    </div>
                                                </div>
                                                {errors.fileError && ( <div className=' text-danger'>{errors.fileError}</div> )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="user_name" className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                    id="user_name"
                                                    name="user_name"
                                                    value={formData?.user_name}
                                                    onChange={(e) => handleChange("user_name", e.target.value)}
                                                    placeholder="Enter Name"
                                                />
                                                {errors.user_name && <div className="text-danger">{errors.user_name}</div>}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="user_email" className="form-label">Email</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                    id="user_email"
                                                    name="user_email"
                                                    value={formData?.user_email}
                                                    onChange={(e) => handleChange("user_email", e.target.value)}
                                                    placeholder="Enter Email"
                                                />
                                                {errors.user_email && <div className="text-danger">{errors.user_email}</div>}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="user_login_id" className="form-label">Username</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.user_login_id ? 'is-invalid' : ''}`}
                                                    id="user_login_id"
                                                    name="user_login_id"
                                                    value={formData?.user_login_id}
                                                    onChange={(e) => handleChange("user_login_id", e.target.value)}
                                                    placeholder="Enter Login id"
                                                />
                                                {errors.user_login_id && <div className="text-danger">{errors.user_login_id}</div>}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="user_login_password" className="form-label">Password</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.user_login_password ? 'is-invalid' : ''}`}
                                                    id="user_login_password"
                                                    name="user_login_password"
                                                    value={formData?.user_login_password}
                                                    onChange={(e) => handleChange("user_login_password", e.target.value)}
                                                    placeholder="Enter Password"
                                                />
                                                {errors.user_login_password && <div className="text-danger">{errors.user_login_password}</div>}
                                            </div>
                                        </form>
                                        <div className=' mt-3'>
                                            <SubmitButton onClick={(e)=>{ 
                                                if(!loadingPost){
                                                    setLoadingPost(true);
                                                    handleSubmit(e);
                                                } }}
                                            loading={loadingPost}
                                            disabled={!formData?.user_name || !formData?.user_email || !formData?.user_login_id || !formData?.user_login_password || loadingPost} 
                                            loadingMessage='Loading' buttonName={formData?.user_id ? "Update":"Create" } icon={'ri-user-add-line'} 
                                            type='primary' iconSide='left' />
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        )}
                        <div className=' row card-body'>
                            {/* <div className="col-md-5">
                                <div style={{"minHeight": "65vh"}} className="card">
                                
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">{formData?.module_id ? "Update" : "Create"} Navigation Header</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={handleSubmit} className="row">
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="user_name" className="form-label">Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                            id="user_name"
                                                            name="user_name"
                                                            value={formData?.name}
                                                            onChange={(e) => handleChange("user_name", e.target.value)}
                                                            placeholder="Enter Name"
                                                        />
                                                        {errors.user_name && <div className="text-danger">{errors.user_name}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="user_email" className="form-label">Email</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                            id="user_email"
                                                            name="user_email"
                                                            value={formData?.user_email}
                                                            onChange={(e) => handleChange("user_email", e.target.value)}
                                                            placeholder="Enter Email"
                                                        />
                                                        {errors.user_email && <div className="text-danger">{errors.user_email}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="user_login_id" className="form-label">User Login Id</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.user_login_id ? 'is-invalid' : ''}`}
                                                            id="user_login_id"
                                                            name="user_login_id"
                                                            value={formData?.user_login_id}
                                                            onChange={(e) => handleChange("user_login_id", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.user_login_id && <div className="text-danger">{errors.user_login_id}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="user_login_password" className="form-label">User login Password</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.user_login_password ? 'is-invalid' : ''}`}
                                                            id="user_login_password"
                                                            name="user_login_password"
                                                            value={formData?.user_login_password}
                                                            onChange={(e) => handleChange("user_login_password", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.user_login_password && <div className="text-danger">{errors.user_login_password}</div>}
                                                    </div>
                                                    
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        <button
                                                            disabled={!formData?.user_name || !formData?.user_email || !formData?.user_login_id || !formData?.user_login_password || loadingPost}
                                                            type="submit"
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                        >
                                                            <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                            {!loadingPost? formData?.module_id ? "Update" : "Save" : "Loading..."}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-md-12">
                                <div className='card'>
                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="  col-md-12">
                                        <table className={`position-relative table table-bordered table-stripped `}>
                                            <thead className='table-light sticky-top z-1'>
                                                <tr>
                                                    <th style={{ width:"10%"}}>Date</th>
                                                    <th style={{ width:"20%"}}>Name</th>
                                                    <th style={{ width:"20%"}}>Email</th>
                                                    <th style={{ width:"15%"}}>Username</th>
                                                    {/* <th style={{ width:"15%"}}>Password</th> */}
                                                    <th style={{ width:"10%"}} className=' text-center'>Status</th>
                                                    { decodedData?.includes(3) && (
                                                    <th style={{ width:"10%"}} className=' text-center'>Action</th>)}
                                                </tr>
                                            </thead>
                                            {rows?.length === 0 ?
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={8}>
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody> :
                                                <tbody>
                                                    {
                                                        rows?.map((row) => {
                                                            return <tr key={row.company_user_id}>
                                                                <td>{row?.updated_date? formatDate(row?.updated_date) : "--"}</td>
                                                                <td>{row.company_user_name || "--"}</td>
                                                                <td>{row.company_user_email || "--"}</td>
                                                                <td>{row.company_user_login_id || "--"}</td>
                                                                {/* <td>
                                                                    <div className=' d-flex align-items-center'>
                                                                        <div style={{ width:"90%"}} className={`${showPassword === row?.company_user_id? "text-primary":""}`}>
                                                                             {showPassword === row?.company_user_id?
                                                                             (row.user_login_password || "--"):
                                                                             ("••••••••")}
                                                                        </div>
                                                                        <div style={{ width:"10%"}} >
                                                                            {showPassword === row?.company_user_id?
                                                                            (
                                                                                <i onClick={()=>{ setShowPassword(false) }} className={` ri-eye-line label-icon cursorPointer text-primary align-middle fs-16`} />
                                                                            ):
                                                                            (
                                                                                <i onClick={()=>{ setShowPassword(row?.company_user_id) }} className={` ri-eye-off-line label-icon cursorPointer align-middle fs-16`} />
                                                                            )}
                                                                            
                                                                        </div>
                                                                    </div>
                                                                </td> */}
                                                                <td className=' text-center'>
                                                                    {/* {row?.header_status == '1' ? <span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-success text-white'>On</span>:<span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-warning text-white'>Off</span> } */}
                                                                    <ToggleSwitch isActive={row?.company_user_status == '1'} isExtFunc={true} onToggle={() => { handleToggleSwitch(row?.company_user_id,row?.company_user_status == "1" ? false : true) }} />
                                                                </td> 
                                                                { decodedData?.includes(3) && (
                                                                <td className='d-flex justify-content-around'>
                                                                     { decodedData?.includes(3) && (
                                                                        <button type='button' onClick={() => {  getInfo(row) }} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                    {/* <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                                    {/* <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> */}
                                                                </td>)}
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            }

                                        </table>
                                    </div>
                                </div>

                            </div>
                            {/* <div className="col-md-12">
                                <div className="card">
                                    <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-md-12">
                                        <table className="position-relative table table-bordered table-stripped">
                                            <thead className="table-light sticky-top z-1">
                                                <tr>
                                                    <th>Module Name</th>
                                                    <th>Parent Name</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {moduleData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={4}>
                                                            <div>No Records Found</div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    renderRows(moduleData)
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card">
                                    <div>
                                        <h1>Menu</h1>
                                        <MenuTree menu={menu} selected={menu} onChange={handleSelectionChange} />
                                        <button
                                            onClick={() =>
                                            console.log(
                                                "Selected Items:",
                                                JSON.stringify(menu, null, 2)
                                            )
                                            }
                                        >
                                            Log Selected Items
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserCreate;
